<template>
  <section class="edit-container">
    <h2>Edit Claim Request</h2>
    <div class="abs-top-right">
      <v-button @click="$emit('cancel')">Cancel</v-button>
      <v-button
        type="primary"
        @click="handlerSave">Save</v-button>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
    >
      <div class="form-container">
        <div class="form-item">
          <span>Accident Date</span>
          <v-date-picker v-model="formData.accident_date" />
        </div>
        <div class="form-item">
          <!--          <span>Contact Person</span>-->
          <el-form-item
            ref="contact_person"
            prop="contact_person"
            label="Contact Person">
            <v-input v-model="formData.contact_person" />
          </el-form-item>
        </div>
        <div class="form-item">
          <!--          <span>Contact Number</span>-->
          <el-form-item
            ref="contact_no"
            prop="contact_no"
            label="Contact Number">
            <v-input
              v-model="formData.contact_no" />
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Brief Description Of The Accident</span>
          <v-input
            v-model="formData.description"
            type="textarea"
            :rows="4" />
        </div>
        <h3>Documents</h3>
        <div class="mg-b-15">
          <span
            v-for="(item, index) in claimFormList"
            :key="index"
            class="font-16 blue pointer block"
            @click="downloadClaimForm(item.url)">{{ item.name }}</span>
        <!-- <v-button
          type="warning"
          @click="downloadClaimForm">Download Claim Form</v-button> -->
        </div>
        <section v-if="formData.other_file && formData.other_file.length > 0">
          <file-container
            v-for="(item, index) in formData.other_file"
            :key="index"
            :fileData="item"
            :edit="true"
            :otherData="{
              index
            }"
            @uploadSuccess="handlerUploadSuccess"
            @delete="deleteOtherFile">
          <!-- document{{ index+1 }} -->
          </file-container>
        </section>
        <v-upload
          @uploadSuccess="handlerUploadSuccess" />
      </div>
    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import FileContainer from '@/views/components/file-container'
import {editTicketClaim, getClaimForm} from '@/api/ticket'
import MixinRules from '@/mixins/rules'

export default {
  name: 'EditClaim',
  components: {
    FileContainer
  },
  mixins: [MixinOptions,MixinRules],
  props: {
    ticketId: [Number, String],
    customerId: Number,
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        accident_date: '',
        contact_person: '',
        contact_no: '',
        description: '',
        other_file: []
      },
      // claimFormUrl: '',
      claimFormList: []
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        let {accident_date} = val||{}
        let date = ''
        if(accident_date){
          let time = accident_date.split('-')
          date =`${time[2]}-${time[1]}-${time[0]}`
        }
        this.formData = Object.assign(this.formData, JSON.parse(JSON.stringify(val)))
        this.formData.accident_date = date||''
        if(val.order_id) {
          this.network().getClaimForm()
        }

      }
    }
  },
  methods: {
    handlerSave() {
      this.$refs.form.validate((valid, rules) => {
        if (valid) {
          this.network().editTicketClaim()
        }else{
          this.scrollToValidDom(rules)
          this.$message({
            type: 'warning',
            message: '請填寫需填的信息'
          })
        }
      })
    },

    deleteOtherFile({ index }) {
      this.formData.other_file.splice(index, 1)
    },
    // 上傳完文件
    handlerUploadSuccess({ data, otherData }) {
      const { index = '' } = otherData
      const { name, id } = data
      if(index !== '') {
        this.$set(this.formData.other_file, index, data)
      }
      else {
        this.formData.other_file.push(data)
      }
    },
    downloadClaimForm(url) {
      window.open(url, '_blank')
      // if(!this.claimFormUrl) {
      //   await this.network().getClaimForm()
      // }
      // window.open(this.claimFormUrl, '_blank')
    },
    network() {
      return {
        editTicketClaim: async () => {
          const { data } = await editTicketClaim({
            ticket_id: this.ticketId,
            // customer_id: this.customerId,
            ...this.formData
          })
          this.$emit('save')
        },
        getClaimForm: async () => {
          const { data } = await getClaimForm({
            order_id: this.form.order_id,
            hideLoading: true
          })
          this.claimFormList = data.claim_form_download
          // this.claimFormUrl = data.download_url
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-container {
    position: relative;
    padding: 15px;
    .abs-top-right {
        top: 20px;
        right: 15px;
    }
    .form-container {
        width: 370px;
    }
}
</style>
